import LangSelector from "./components/lang-selector";
import SiteHeader from "./components/site-header";
import BlogSlider from "./components/blog-slider";
import PortalPageSlider from "./components/portal-page-slider";
import HandheldMenu from "./components/handheld-menu";
import CookiesConsent from "./components/cookies-consent";
import DropdownMenu from "./components/dropdown-menu";
import Accordion from "./components/accordion";
import Tabs from "./components/tabs";
import NewsletterForm from "./components/newsletter-form";
import DeviceManager from "./utils/device-manager";
import ScrollInView from "./components/scroll-in-view";
import BlogTags from "./components/blog-tags";
import Contact from "./components/contact";

(function ($) {
	window.$ = $;

	$(function () {
		const $html = $("html");

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass("touch");

			if (DeviceManager.isIos()) {
				$html.addClass("ios");
			}
		} else {
			$html.addClass("no-touch");
		}

		// IE detection
		if (DeviceManager.isIe11()) {
			$html.addClass("ie11");
		} else if (DeviceManager.isEdge()) {
			$html.addClass("edge");
		}

		// General components
		const langSelector = new LangSelector($(".language-selector"));
		const siteHeader = new SiteHeader($(".site-header"), 20);
		// const dropdownMenu = new DropdownMenu($('.header__nav'));

		// BLOG slider component
		const $blogSliders = $(".blog-slider");
		if ($blogSliders.length) {
			$blogSliders.each(function (index, el) {
				const blogSlider = new BlogSlider($(el));
			});
		}

		// Portal page slider component
		const $portalPageSliders = $(".portal-page__header-slider");
		if ($portalPageSliders.length) {
			$portalPageSliders.each(function (index, el) {
				const portalPageSlider = new PortalPageSlider($(el));
			});
		}

		// Reviews slider component
		const $reviewsSlider = $(".reviews__slider");
		if ($reviewsSlider.length) {
			$reviewsSlider.each(function (index, el) {
				const reviewsSlider = new ReviewsSlider($(el));
			});
		}

		// Newsletter form component
		const $newsletterFormElements = $(".footer-block.footer-block--newsletter-style");
		if ($newsletterFormElements.length) {
			$newsletterFormElements.each(function (index, el) {
				const newsletterForm = new NewsletterForm(el);
			});
		}

		// Scroll in view component
		const $scrollInViewElements = $(".scroll-in-view");
		if ($scrollInViewElements.length) {
			$scrollInViewElements.imagesLoaded(function () {
				const scrollInView = new ScrollInView($scrollInViewElements);
				window.scrollInView = scrollInView;
			});
		}

		// Cookie consent
		if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
			// Tarteaucitron cookie settings
			let tarteaucitronLang = "fr";

			const cookiesConsent = new CookiesConsent(tarteaucitronLang);
		}

		$(".mediatheque-filters li.cat-has-children").on("mouseenter", function (e) {
			const $target = $(e.currentTarget);
			const $children = $target.find("> .children");

			if ($children.length) {
				$(".mediatheque-filters").css("padding-bottom", $children.outerHeight());
			}
		});
		$(".mediatheque-filters li.cat-has-children").on("mouseleave", function (e) {
			$(".mediatheque-filters").css("padding-bottom", 0);
		});

		if (window.matchMedia("(max-width: 767px)").matches) {
			$(".mediatheque-filters .cat-has-children > a").click(function () {
				event.preventDefault();

				var $this = $(this);
				var $catItem = $this.parent(".cat-has-children");

				$catItem.toggleClass("opened");
			});
		}

		/**
		 * Personnalisation carte
		 */
		$(window).on('marker:selected', function (event, data) {
			if (data.store) {
				if (data.store.phone) $('.store-detail-phone').attr('href', 'tel:' + data.store.phone);
				if (data.store.email) $('.store-detail-email').attr('href', 'mailto:' + data.store.email);

				// On supprime Colorbox par défaut
				$('.store-detail-appointment-attr').colorbox.remove();

				if (data.store.appointment) {
					$('.store-detail-appointment-attr').attr('href', data.store.appointment).show();

					// On n'active pas la pop-in Colorbox si on a une URL pointant vers Hapicare
					if(data.store.appointment.indexOf('hapicare') == -1) {
						$('.store-detail-appointment-attr').colorbox({
							iframe: true,
							width: "80%",
							height: "80%"
						});
					}
				} else {
					$('.store-detail-appointment-attr').hide();
				}

				$('.map-tags').empty();
				data.store.specialities.forEach(function (id) {
					$('.map-tags').append(
						$('<p>').addClass('map-tag').text(specialities[id])
					);
				});
			}
		});

		// Mise à jour des spécialités selon le service choisi
		$('#service').on('change', function () {
			var s = $(this).val();

			$.ajax({
					url: '/specialities.json',
					data: {
						service: s
					},
					beforeSend: function () {
						$('#specialite').empty().append(
							$('<option>').text('Chargement…')
						);
					}
				})
				.done(function (data) {
					$('#specialite').empty();
					$('#specialite').append(
						$('<option>').val(0).text("Toutes les spécialités")
					);

					$.each(data, function (id, name) {
						$('#specialite').append(
							$('<option>').val(id).text(name)
						);
					});

				});
		});

		/**
		 * Page paiement en ligne
		 */
		if ($('.page-template-page-paiement').length) {
			$('#center').on('change', function () {
				var id = $(this).val();

				$('.centers').hide();
				$('#center-' + id).fadeIn();
			});
		}
	});
})(jQuery);